import React from 'react';
import { InputNumber, Typography, Space, Card, theme } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export interface QuizDeadlineValues {
  deadlineDays: number;
  deadlineHours: number;
}

export const DEFAULT_QUIZ_DEADLINE: QuizDeadlineValues = {
  deadlineDays: 1,
  deadlineHours: 0,
};

interface QuizDeadlineConfigProps {
  config: QuizDeadlineValues;
  onChange: (config: QuizDeadlineValues) => void;
}

const QuizDeadlineConfig: React.FC<QuizDeadlineConfigProps> = ({ config, onChange }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Card 
      size="small" 
      style={{ 
        marginBottom: 16,
        background: token.colorBgContainer,
        border: '1px solid #ffbb96',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(250, 84, 28, 0.08)'
      }}
      title={
        <Space>
          <ClockCircleOutlined style={{ color: '#fa541c', fontSize: 18 }} />
          <Text strong style={{ fontSize: 15 }}>
            {t('quiz.deadline', 'Completion Deadline')} <span style={{ color: 'red' }}>*</span>
          </Text>
        </Space>
      }
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Text type="secondary" style={{ fontSize: 13, textAlign: 'center', display: 'block' }}>
          {t('quiz.deadlineDescription', 'How much time do participants have to complete the quiz before they automatically forfeit?')}
        </Text>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Space>
            <InputNumber
              min={0}
              max={30}
              value={config.deadlineDays}
              onChange={(value) => onChange({ ...config, deadlineDays: value ?? 0 })}
              style={{ width: 80 }}
            />
            <Text strong>{t('quiz.days', 'days')}</Text>
          </Space>
          <Space>
            <InputNumber
              min={0}
              max={23}
              value={config.deadlineHours}
              onChange={(value) => onChange({ ...config, deadlineHours: value ?? 0 })}
              style={{ width: 80 }}
            />
            <Text strong>{t('quiz.hours', 'hours')}</Text>
          </Space>
        </div>
        {(config.deadlineDays === 0 && config.deadlineHours === 0) && (
          <Text type="danger" style={{ fontSize: 12, textAlign: 'center', display: 'block' }}>
            {t('quiz.deadlineRequired', 'You must enter at least 1 hour or 1 day.')}
          </Text>
        )}
      </Space>
    </Card>
  );
};

export default QuizDeadlineConfig;
